import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import "@shopify/polaris/dist/styles.css";
import "asset/styles/reset.css";
import "asset/styles/global.css";

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
